var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ios") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22_Mobile-Applications",
    transform: "translate(-380.000000, -236.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(320.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trustgrid-Citizen-App",
    transform: "translate(40.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ioS",
    transform: "translate(0.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.996,22.0732813 L39.3633594,22.6253281 L38.8346562,23.0242813 C38.0793594,23.5941875 36.7012344,24.6337813 36.7012344,26.6930469 C36.7012344,29.132 38.2619844,30.0699688 39.0117969,30.5210938 C39.3427812,30.7202188 39.6853906,30.9255313 39.6853906,31.3745938 C39.6853906,31.6677969 37.3452969,37.963625 33.9470937,37.963625 C33.1155781,37.963625 32.5278125,37.7136875 32.009375,37.4932813 C31.4847969,37.2701094 31.0322656,37.077875 30.2845156,37.077875 C29.9054844,37.077875 29.4261875,37.2570781 28.9187656,37.4472969 C28.2253437,37.7060938 27.4404687,38 26.5498906,38 L26.5265469,38 C22.954625,37.9794219 20,30.6879219 20,26.9745313 C20,20.9087188 24.5503906,19.58075 26.3040781,19.58075 C27.0943906,19.58075 27.9382812,19.8911094 28.6826094,20.16575 C29.2031094,20.3573281 29.7414219,20.5550938 30.0408125,20.5550938 C30.2200156,20.5550938 30.6423125,20.3868594 31.0151562,20.23925 C31.8102969,19.9227031 32.7997344,19.5292813 33.9519219,19.5292813 C34.8191094,19.5292813 37.4277031,19.7180938 38.996,22.0732813 Z M34.3119219,14 C34.4004219,17.1910625 32.1183125,19.404875 29.838875,19.2660313 C29.4632656,16.7194531 32.1180312,14 34.3119219,14 Z",
    id: "ios"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.b77e177b84cb44c8700ad9b1951bd150.svg";
export { ForwardRef as ReactComponent };